'use client';

import React, { useEffect } from 'react';
import Head from 'next/head';
import { Layout } from '../../components/Layout';
import { useSegmentPage } from '../../hooks/useSegmentPage';
import { HealthFaqsSection } from './components/HealthFaqsSection';
import { HealthHeroHeaderSection } from './components/HealthHeroHeaderSection';
import { HealthHowItWorksSection } from './components/HealthHowItWorksSection';
import { HealthSchemas } from './components/HealthSchemas';
import { HealthStatesSection } from './components/HealthStatesSection';
import { HealthStatsSection } from './components/HealthStatsSection';
import { MeetTheVetsCarouselSection } from './components/MeetTheVetsCarouselSection';
import { TestimonialsCarouselSection } from './components/TestimonialsCarouselSection';
export const HealthServicePage = () => {
  const {
    execute: executeSegmentPage
  } = useSegmentPage();
  useEffect(() => {
    executeSegmentPage();
  }, [executeSegmentPage]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="HealthServicePage.tsx">
        <title>Chat with a Veterinarian Professional Online | Wag!</title>
        <meta name="description" content="24/7 online vet advice. Get access to expert advice for a range of symptoms and conditions right from your phone. Chat with a vet or vet tech where you are, same day." data-sentry-element="meta" data-sentry-source-file="HealthServicePage.tsx" />
        <meta name="robots" content="index, follow" data-sentry-element="meta" data-sentry-source-file="HealthServicePage.tsx" />
        <link rel="canonical" href="https://wagwalking.com/wag-health" />
      </Head>

      <Layout data-sentry-element="Layout" data-sentry-source-file="HealthServicePage.tsx">
        <HealthHeroHeaderSection data-sentry-element="HealthHeroHeaderSection" data-sentry-source-file="HealthServicePage.tsx" />
        <HealthHowItWorksSection data-sentry-element="HealthHowItWorksSection" data-sentry-source-file="HealthServicePage.tsx" />
        <HealthStatsSection data-sentry-element="HealthStatsSection" data-sentry-source-file="HealthServicePage.tsx" />
        <MeetTheVetsCarouselSection data-sentry-element="MeetTheVetsCarouselSection" data-sentry-source-file="HealthServicePage.tsx" />
        <TestimonialsCarouselSection data-sentry-element="TestimonialsCarouselSection" data-sentry-source-file="HealthServicePage.tsx" />
        <HealthFaqsSection data-sentry-element="HealthFaqsSection" data-sentry-source-file="HealthServicePage.tsx" />
        <HealthStatesSection data-sentry-element="HealthStatesSection" data-sentry-source-file="HealthServicePage.tsx" />
      </Layout>

      <HealthSchemas data-sentry-element="HealthSchemas" data-sentry-source-file="HealthServicePage.tsx" />
    </>;
};